import axios from 'axios'
import React, {useEffect, useState} from 'react'
import {useHistory, useParams} from 'react-router-dom'
import {EDIT_NOTE_ENTRY_FORM_INPUTS} from '../../../caregiver/ADD_NOTES_FORM_CONSTANTS'
import DynamicForm from '../../../../reusable-components/forms/DynamicForm'
import {toast} from 'react-toastify'
import dayjs from 'dayjs'
import {LocalizationProvider} from '@mui/x-date-pickers'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'
import {Typography} from '@mui/material'
import {MoonLoader} from 'react-spinners'
import FormWrapper from '../../../../reusable-components/Wrapper/Wrapper'
import {RootState} from '../../../../../setup'
import {useSelector} from 'react-redux'
import DescriptionModal from '../../../../reusable-components/description-modal/descriptionmodal'
import NavigateButton from '../../../../reusable-components/description-modal/navigatebutton'
import FrequencyDateRangePicker from '../../../../reusable-components/NoteType/NoteType'
const selectTimeZone = (state: RootState) => state.timeZone.timeZone

const DeletedCaregiverNoteForm = () => {
  const params: {id: string} = useParams()
  const [uiElements, setUIElements] = useState([])
  const [isFormLoading, setIsFormLoading] = useState(true)
  const [clickCount, setClickCount] = useState(20)
  const [scoringMethod, setScoringMethod] = useState([])
  const [updateRolesFields, setUpdateRolesFields] = useState(false)
  const [userTasks, setUserTasks] = useState([])
  const timeZone = useSelector(selectTimeZone)
  const [LocationDetails, setLocationDetails] = useState({
    label: '',
    value: '',
  })
  const [inputArr, setInputArr] = useState([
    {
      taskId: '',
      taskName: '',
      taskDescription: '',
      score: '',
      description: '',
    },
  ])
  const [formData, setFormData] = useState({
    startDate: null,
    endDate: null,
    timeIn: '',
    timeOut: '',
    noteType: '',
  })
  const [clientid, setClientId] = useState<string | null>(null)

  const buttons = [{label: 'Cancel', variant: 'outlined', type: 'button'}]

  useEffect(() => {
    fetchData()
  }, [])

  const formatLocation = (address) => {
    return `${address.st1 || ''} ${address.st2 || ''}, ${address.city || ''}, ${address.state || ''}, ${address.country || ''} ${address.zipCode || ''}`.trim()
  }

  const fetchData = async () => {
    setIsFormLoading(true)

    try {
      const res = await axios.get(`/notesEntry/getById/${params.id}`)

      const tempArrForInputArr = []
      const tempArrayForScoringMethod = []
      const prevFormData = {...formData}

      let programName = res.data.programId
      try {
        const programRes = await axios.get(`/programs/getOne/${res.data.programId}`)
        programName = programRes?.data?.programName || res.data.programId
      } catch (err) {
        console.warn('Failed to fetch program name, using ID instead.')
      }
      res.data.taskList.forEach((eachTask, localIndex) => {
        const taskNameKeyName = `${localIndex}taskName`
        const taskDescriptionKeyName = `${localIndex}taskDescription`
        const scoreKeyName = `${localIndex}score`
        const descriptionKeyName = `${localIndex}description`
        const formattedStartDate = dayjs.utc(res.data.beginTime).tz(timeZone, true)
        const formattedEndDate = dayjs.utc(res.data.endTime).tz(timeZone, true)

        prevFormData['startDate'] = formattedStartDate
        prevFormData['endDate'] = formattedEndDate
        prevFormData['timeIn'] = res?.data?.timeIn
        prevFormData['timeOut'] = res?.data?.timeOut
        prevFormData['noteType'] = res?.data?.noteType
        prevFormData[taskNameKeyName] = eachTask.taskName
        prevFormData[taskDescriptionKeyName] = eachTask.taskDescription
        prevFormData[scoreKeyName] = res.data.tasks[localIndex]?.score || ''
        prevFormData[descriptionKeyName] = res.data.tasks[localIndex]?.description || ''
        prevFormData['nextSession'] = res?.data?.nextSession
        prevFormData['longTermObjectives'] = res?.data?.longTermObjectives
        prevFormData['materialsRequired'] = res?.data?.materialsRequired
        prevFormData['noteName'] = res?.data?.noteName
        prevFormData['programId'] = programName
        prevFormData['reasonForNotes'] = res?.data?.reasonForNotes
        prevFormData['serviceId'] = res?.data?.serviceId
        prevFormData['criteriaForCompletion'] = res?.data?.criteriaForCompletion
        prevFormData['goals'] = res?.data?.goals
        prevFormData['evaluation'] = res?.data?.evaluation

        tempArrForInputArr.push({
          taskName: eachTask.taskName,
          taskDescription: eachTask.taskDescription,
          score: res.data.tasks[localIndex]?.score || '',
          description: res.data.tasks[localIndex]?.description || '',
          taskId: eachTask._id,
        })
      })

      res.data.scoringMethod[0]?.scoringLevels.forEach((obj) => {
        tempArrayForScoringMethod.push({
          label: `${obj.levelAcronym} (${obj.levelName})`,
          value: obj._id,
        })
      })
      if (res?.data?.location) {
        const locationResponse = await axios({
          method: 'get',
          url: `/address/getOne/${res.data.location}`,
        })

        const formattedLocation = {
          label: formatLocation(locationResponse.data),
          value: locationResponse.data._id,
        }

        setLocationDetails(formattedLocation)
        prevFormData['location'] = formattedLocation.label
      }
      prevFormData['enteredBy'] = `${res?.data?.user[0]?.firstName} ${res?.data?.user[0]?.lastName}`

      setUIElements(
        EDIT_NOTE_ENTRY_FORM_INPUTS(
          `${res?.data?.user[0]?.firstName.toUpperCase()} ${res?.data?.user[0]?.lastName.toUpperCase()}`
        ).map((item) => ({
          ...item,
          disabled: true,
        }))
      )
      setClientId(res.data.clientId)
      setUserTasks(res.data.taskList)
      setScoringMethod(tempArrayForScoringMethod)
      setInputArr(tempArrForInputArr)
      setFormData(prevFormData)
      setUpdateRolesFields((prevState) => !prevState)
    } catch (error) {
      if (error.response) {
        toast.error(`Error: ${error.response.data.message || 'Something went wrong'}`)
      } else if (error.request) {
        toast.error('No response received from the server.')
      } else {
        toast.error(`Error: ${error.message || 'Unknown error occurred'}`)
      }
    } finally {
      setIsFormLoading(false)
    }
  }

  useEffect(() => {
    if (userTasks.length > 0) {
      loadDataAndUI()
    }
  }, [updateRolesFields])

  const loadDataAndUI = () => {
    let tempClickCount = clickCount
    const tempUIArray = [...uiElements] // Create a copy to avoid mutation
    userTasks.forEach((eachTask, taskIndex) => {
      tempClickCount = tempClickCount + 1
      const taskNameFieldToAdd = {
        index: taskIndex,
        label: 'Name',
        name: `${taskIndex}taskName`,
        type: 'text',
        // required: true,
        rowNumber: tempClickCount,
        disabled: true,
        sx: {
          width: '100%',
          marginTop: '0.5rem',
        },
        className: `col-lg-6 col-sm-12 col-md-6 col-12 false false false col-lg-3 col-md-3 col-sm-12 false`,
        value: '',
      }
      const taskDescriptionFieldToAdd = {
        index: taskIndex,
        label: 'Task Description *',
        name: `${taskIndex}taskDescription`,
        type: 'textarea',
        // required: true,
        rowNumber: tempClickCount,
        disabled: true,
        // className: `col-12 col-sm-6 col-md-6 false false false col-lg-3 col-md-3 col-sm-3 false`,
        // textAreaClassName: 'notes-entry-task-description-method-div',
        className: `col-lg-6 col-sm-12 col-md-6 col-12 false false false col-lg-3 col-md-3 col-sm-12 false`,
        // value: ``,
        // textAreaClassName: 'notes-entry-task-description-method-div',
        sx: {
          resize: 'none',
        },
      }
      const scoringMethodFieldToAdd = {
        index: taskIndex,
        label: 'Search Level',
        name: `${taskIndex}score`,
        type: 'select',
        options: scoringMethod,
        // required: true,
        rowNumber: tempClickCount,
        disabled: true,
        className: `col-lg-6 col-sm-12 col-md-6 col-12 false false false col-lg-3 col-md-3 col-sm-12 false`,
        sx: {
          // marginLeft: '3rem',
          width: '100%',
          marginTop: '0.5rem',
        },
      }
      const descriptionFieldToAdd = {
        index: taskIndex,
        label: 'Description',
        name: `${taskIndex}description`,
        type: 'textarea',
        // required: true,
        rowNumber: tempClickCount,
        disabled: true,
        className: `col-lg-6 col-sm-12 col-md-6 col-12 false false false col-lg-3 col-md-3 col-sm-12 false`,
        // textAreaClassName: 'notes-entry-task-remarks-method-div',
      }

      tempUIArray.push(
        taskNameFieldToAdd,
        scoringMethodFieldToAdd,
        taskDescriptionFieldToAdd,
        descriptionFieldToAdd
      )
    })
    setClickCount(tempClickCount)
    setUIElements(tempUIArray)
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <FormWrapper
        title='Deleted Caregiver Note'
        content={
          <>
            {isFormLoading ? (
              <div
                className='overlay d-flex align-middle justify-content-center align-middle'
                style={{marginTop: '100px'}}
              >
                <MoonLoader color='#9db2fc' size={60} loading={isFormLoading} />
              </div>
            ) : (
              <>
                <Typography
                  sx={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    marginBottom: '0.5rem',
                    marginLeft: '1rem',
                  }}
                  color='primary'
                >
                  Note Type
                </Typography>
                <FrequencyDateRangePicker
                  isEntry={true}
                  isTemplate={false}
                  isFullForm={false}
                  isEdit={true}
                  formData={formData}
                  setFormData={setFormData}
                  isDeleted={true}
                />
                <DynamicForm
                  fields={uiElements}
                  data={formData}
                  onSubmit={() => {}}
                  buttons={buttons}
                  disabled={true}
                />
              </>
            )}
          </>
        }
      />
    </LocalizationProvider>
  )
}

export default DeletedCaregiverNoteForm
